'use client';

import dynamic from 'next/dynamic';

// Dynamically import Vimeo with no SSR to avoid ref issues in React 19
const VimeoPlayer = dynamic(() => import('@u-wave/react-vimeo'), {
  ssr: false,
  loading: () => <div style={{ width: '100%', aspectRatio: '16/9', backgroundColor: '#000' }} />,
});

export { VimeoPlayer };
